import clsx from "clsx";
import { ReactNode, forwardRef } from "react";

export const Heading = forwardRef(
    (
        {
            children,
            className,
        }: {
            children: ReactNode;
            className?: string;
        },
        ref,
    ) => {
        return (
            <h3 ref={ref as any} className={clsx("font-semibold text-[#424242]", className)}>
                {children}
            </h3>
        );
    },
);
